import React from 'react';
import styled from 'styled-components';

const QuestionsAndHelp = () => {
	return (
		<HelpContainer>
			<ItalicText>Questions or Need Help? </ItalicText>
			<NormalText>Contact </NormalText>
			<MailLink href="mailto:help@playupusa.com">help@playupusa.com</MailLink>
		</HelpContainer>
	);
};

export default QuestionsAndHelp;

const HelpContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	padding-bottom: 20px;
	border-bottom: 1px solid;
	border-color: ${({ theme }) => theme.colors.lightGreyR};
	margin-bottom: 20px;
`;

const NormalText = styled.p`
	color: #000;
`;

const ItalicText = styled.p`
	color: #000;
	font-style: italic;
	margin-right: 3px;
`;

const MailLink = styled.a`
	color: #000;
	text-decoration: underline;
	margin-left: 3px;
`;
